<template>

    <v-container fluid grid-list-md>

<v-dialog v-model="loading" fullscreen full-width>
  <v-container fluid fill-height style="background-color: rgba(255, 255, 255, 0.5);">
    <v-layout justify-center align-center>
      <v-progress-circular
        indeterminate
        color="primary">
      </v-progress-circular>
    </v-layout>
  </v-container>
</v-dialog>

        <v-layout row>

      <v-flex xs12 class="display-1 font-weight-light text-sm-left">
          My Selected Courses
      </v-flex>

        </v-layout>

        <v-layout row>
      <v-flex xs12>


      </v-flex>
        </v-layout>

        <v-layout row>
      <v-flex xs12>

<v-data-table
    :headers="headers"
    :items="this.myCourses"
    class="elevation-1"
    hide-default-footer
  >
    <template slot="headerCell" slot-scope="props">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <span v-on="on">
            {{ props.header.text }}
          </span>
        </template>
        <span>
          {{ props.header.text }}
        </span>
      </v-tooltip>
    </template>
    <template v-slot:items="props">
        <td>{{ props.item.courseid }}</td>
        <td>{{ props.item.title }}</td>
        <td class="align-center"></td>
        <td class="justify-center">{{ props.item.desired_date }}</td>
        <td class="justify-center layout px-0"></td>
    </template>
    <template v-slot:item.action="{ item }">  
              <v-icon medium class="mr-2"  @click="openCourse(item.courseid)"
                    >pageview</v-icon>
              <v-icon medium  @click="removeCourse(item)"
                    >delete</v-icon>
    </template>
    <template v-slot:item.status="{ item }">  
              {{ statusText(item.status) }}
    </template>
  </v-data-table>

      </v-flex>

        </v-layout>
    </v-container>
</template>


<script>

const fb = require('../firebaseConfig.js')

export default{
  props: ['id'],
  data () {
     return {
         headers: [
         {
            text: 'COURSE #',
            align: 'left',
            sortable: false,
            value: 'courseid'
          },
          { text: 'COURSE NAME', value: 'title' },
          { text: 'STATUS', value: 'status' },
          { text: 'DATE', value: 'desired_date' },
          { text: 'ACTION', value: 'action', align: 'center' },
        ]
     }
  },
  computed: {
    myCourses() {
      return this.$store.getters.signedInUserCourses
    },
    loading() {
      return this.$store.getters.isLoading
    }
  },
  methods: {
    openCourse(id) {
      this.$router.push({ path: '/course/' + id });
    },
    statusText(status) {
      if(status == 0)
      {
        return 'Pending'
      }else if(status == 1)
      {
        return 'Approved'

      }else if(status == 2)
      {
        return 'Rescheduled'

      }else 
      {
        return 'Denied'
      }
    },
    removeCourse(item) {

      if(confirm('Are you sure you want to remove this course?')){

         fb.myCoursesCollection.doc(item.docId).delete().then(() => {

            const index = this.myCourses.indexOf(item)
            this.myCourses.splice(index, 1)

         }).catch(err => {
            this.$store.commit('setError', err)
         })
      }
    }
  },
  mounted() {
    this.$store.getters.getMyCourses
  }
}
</script>

<style>
</style>
